export const openInvoicePdfWindow = (documentLabel = 'invoice') => {
    const pdfWindow = window.open('', '_blank');

    if (!pdfWindow) return null;

    try {
        pdfWindow.opener = null;
        pdfWindow.document.title = `Loading ${documentLabel}...`;
        pdfWindow.document.body.textContent = `Loading ${documentLabel} PDF...`;
    } catch (error) {
        // The blank window can still be navigated if its document is unavailable.
    }

    return pdfWindow;
};

export const navigateInvoicePdfWindow = (pdfWindow, pdfUrl) => {
    if (!pdfWindow || !pdfUrl || pdfWindow.closed) return false;

    try {
        pdfWindow.location.replace(pdfUrl);
        return true;
    } catch (error) {
        return false;
    }
};

export const closeInvoicePdfWindow = (pdfWindow) => {
    if (!pdfWindow || pdfWindow.closed) return;

    try {
        pdfWindow.close();
    } catch (error) {
        // There is nothing else to clean up if the browser already closed it.
    }
};
